import { Directive } from '@angular/core';
import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function WalletAddressValidator(): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    if (c.value === null || c.value.length === 0) {
      return null;
    }

    let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*|']*$/;
    let valid = regex.test(c.value);
    return valid ? null : { walletAddressValidator: true };
  };
}

@Directive({
  selector: '[formControlName],[formControl]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: WalletAddressValidatorDirective,
      multi: true
    }
  ]
})
export class WalletAddressValidatorDirective implements Validator {
  validate(element: AbstractControl): ValidationErrors | null {
    return WalletAddressValidator()(element);
  }
}
